export enum ClientDirectoryPageModalEnum {
  DisconnectClient = 'DisconnectClient',
  DeleteInvitation = 'DeleteInvitation',
}
